import * as angular from "angular";
import {IController, IFilterService, ITimeoutService} from "angular";
import * as _ from "lodash";
import {$agentsFactory} from "../../$agents.factory";

export class AgentsAutocompleteCtrl implements IController {

  selectedAgents: any;
  avoidIds: any;

  onSelect: Function;

  private agentsRef: any;
  private loadLimit: number;
  private searchQuery: string;
  private selectedItems: any;

  constructor(private $agents: $agentsFactory, private $timeout: ITimeoutService, private $filter: IFilterService) {
  }

  $onInit() {
    this.loadLimit = 10;
    this.agentsRef = this.$agents();
    this.selectedItems = []

    if (this.selectedAgents) {
      this.selectedItems = _.map(this.selectedAgents,(agent) => {
        return {
          agent: agent,
          name: agent.user.firstName + agent.user.lastName,
          image: agent.user.avatarUrl || '/assets/images/avatars/default-agent-avatar.png'
        }
      })
    }
  }

  agentNameFilter(agent) {
    return this.$filter<any>('userName')(agent.user);
  }

  onSearch(searchQuery) {

    const query = {
      isDemand: false,
      limit: this.loadLimit,
      descending: true,
      query: searchQuery,
      active: true
    };

    return this.agentsRef.$getAll(query)
      .then((agentIds) => {
        if (this.avoidIds && !_.isEmpty(this.avoidIds)) {
          agentIds = _.filter(agentIds,(agentId) => {
            return _.indexOf(this.avoidIds, agentId) === -1
          })
        }
        return this.agentsRef.$asyncValues(agentIds)
          .then((agents) => {
            return _.map(agents,(a) => {
              return {
                agent: a,
                name: a.user.firstName + a.user.lastName,
                image: a.user.avatarUrl || '/assets/images/avatars/default-agent-avatar.png'
              }
            })
          })
      });
  }

  onSelectItem() {
    this.$timeout(0).then(() => {
      let agents = _.map(this.selectedItems,(item) => {
        return item.agent;
      });
      this.onSelect({agents: agents})
    })
  }




}

angular
  .module('bringoz.admin.agents')
  .component('agentsAutocomplete', {
    bindings: {
      selectedAgents: '<',
      avoidIds: '<?',
      onSelect: '&'
    },
    template: require('./agents-autocomplete.html').default,
    controller: AgentsAutocompleteCtrl
  });
